<div class="vrf-context-modal-preview">
    <div class="vrf-context-modal-preview__section">
        <div class="vrf-context-modal-preview__sub-section">
            <cds-icon
                shape="help-info"
                size="24"
                class="vrf-context-modal-preview__help-info"
            ></cds-icon>

            <span class="vrf-context-modal-preview__sub-section-header">{{ l10nKeys.managementVrfContextLabel | vtranslate }}</span>

            <cds-icon
                class="vrf-context-modal-preview__toggle-icon"
                direction="{{ isExpanded ? 'up' : 'down' }}"
                shape="angle"
                size="24"
                (click)="onToggleButtonClick()"
            ></cds-icon>
        </div>

        <div *ngIf="isExpanded">
            <p class="vrf-context-modal-preview__vrf-context-info">
                {{ l10nKeys.mangementVrfContextInfo | vtranslate }}
            </p>
            <p class="vrf-context-modal-preview__seg-network-override-info">
                {{ l10nKeys.segNetworkOverrideInfo | vtranslate }}
            </p>

            <div class="vrf-context-modal-preview__notes-container">
                <div class="vrf-context-modal-preview__notes-container-heading">{{ l10nKeys.noteLabel | vtranslate }}</div>
                <p>{{ l10nKeys.defaultGatewayNote | vtranslate }}</p>
            </div>
        </div>
    </div>

    <div class="vrf-context-modal-preview__item-preview-defaults">
        <item-preview-defaults 
            [config]="config"
            [isItem]="true"
        ></item-preview-defaults>
    </div>
</div>
